import React, { useState, useEffect } from "react";
import axios from "axios";
import Dummylayout from "../pages/Dummylayout";
import BasicCard from "../pages/BasicCard";

import * as ReactBootstrap from "react-bootstrap";
import { baseURL } from "../config";
const Notifications = () => {
  const [employeenotifications, setEmployeeNotifications] = useState([]);
  const [posts, setPosts] = useState({ notifications: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  useEffect(() => {
    const fetchEmployeeNotifications = async () => {
      try {
        const id = localStorage.getItem("userid");
        const response = await axios.get(
          `${baseURL}/getNotifications?id=` + id
        );
        const data = response.data;
        let arrEmployee = data.notifications;
        setEmployeeNotifications(arrEmployee);
        setPosts(data);

        // fetchAppraisalTemplate(gradeid);
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }
    };
    fetchEmployeeNotifications();
  }, []);
  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts?.notifications?.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  return (
    <>
      <Dummylayout />

      <BasicCard>
        <div className="col-lg-12">
          <div className="row ">
            <div className="col-12 ">
              <div className="col-lg-12 d-flex mt-2 pb-3">
                <div className="col-lg-6">
                  <h4 className="text-start">My Notifications</h4>
                </div>
              </div>
              <ReactBootstrap.Table striped bordered hover size="sm">
                <thead className="text-center">
                  <tr>
                    <th>#</th>
                    <th>Notification Message</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {currentPosts && currentPosts.length > 0 ? (
                    currentPosts.map((msg, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{msg.notification}</td>
                        <td className="text-center">
                          {formatDate(msg.datecreated)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No notifications
                      </td>
                    </tr>
                  )}
                </tbody>
              </ReactBootstrap.Table>

              <ReactBootstrap.Pagination>
                {Array.from(
                  {
                    length: Math.ceil(
                      posts?.notifications?.length / postsPerPage
                    ),
                  },
                  (_, index) => (
                    <ReactBootstrap.Pagination.Item
                      key={index}
                      onClick={() => paginate(index + 1)}
                    >
                      {index + 1}
                    </ReactBootstrap.Pagination.Item>
                  )
                )}
              </ReactBootstrap.Pagination>
            </div>
          </div>
        </div>
      </BasicCard>
    </>
  );
};

export default Notifications;
